const mixIns = {
  allCaps: "text-transform: uppercase;",
  centerChild: `display: flex; justify-content: center; align-items: center;`,
};
export default mixIns;
